import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
    Accordion,
    AccordionHeader,
    AccordionItem,
    AccordionPanel,
    Badge,
    Button,
    Caption1,
    Divider,
    Subtitle2,
    Text,
} from '@fluentui/react-components';
import { useBoolean } from '@fluentui/react-hooks';

import * as ComponentFunctions from './ConsumptionToSettle.Functions';
import './ConsumptionToSettle.Styles.css';
import SettlementFormComponent from '../../Settlements/SettlementForm/Settlement.Form.Component';

const fmt = (amount: number, currency: string) =>
    (amount ?? 0).toLocaleString('es-AR', { style: 'currency', currency: currency.toUpperCase() });

const ConsumptionToSettleComponent = (props: ComponentFunctions.Props) => {

    const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] = useBoolean(false);

    useEffect(() => {
        props.GetAllProtocolContractAssociations(props.ProtocolId);
    },
    [props.contract?.id === undefined]);

    useEffect(() => {
        props.GetProtocolConsumptionToSettle(props.ProtocolId);
    },
    [props.ProtocolId !== undefined]);

    return (
        <div className="cts-wrapper">
            <div className="cts-currencies">
                <Accordion multiple collapsible>
                    {props.TotalByCurrency?.map((total) => {
                        const concepts = props.Totals?.filter(
                            t => t.CurrencyValue.toUpperCase() === total.Currency.toUpperCase()
                        ) ?? [];

                        return (
                            <AccordionItem key={total.Currency} value={total.Currency}>
                                <AccordionHeader expandIconPosition="end">
                                    <div className="cts-header-content">
                                        <Badge appearance="filled" color="brand">
                                            {total.Currency.toUpperCase()}
                                        </Badge>
                                        <div className="cts-total-block">
                                            <span className="cts-total-label">Total a liquidar</span>
                                            <Text size={500} weight="semibold">
                                                {fmt(total.Total, total.Currency)}
                                            </Text>
                                        </div>
                                    </div>
                                </AccordionHeader>
                                <AccordionPanel>
                                    <div className="cts-panel-content">
                                        <div>
                                            <Subtitle2 className="cts-section-title">División de honorarios</Subtitle2>
                                            <div className="cts-honor-grid">
                                                <div className="cts-honor-item">
                                                    <Caption1>Centro médico</Caption1>
                                                    <Text size={200} weight="semibold">{fmt(total.TotalOwner, total.Currency)}</Text>
                                                </div>
                                                <div className="cts-honor-item">
                                                    <Caption1>Investigador Principal</Caption1>
                                                    <Text size={200} weight="semibold">{fmt(total.TotalTeam, total.Currency)}</Text>
                                                </div>
                                            </div>
                                        </div>

                                        {concepts.length > 0 && (
                                            <>
                                                <Divider />
                                                <div>
                                                    <Subtitle2 className="cts-section-title">Por concepto</Subtitle2>
                                                    <div className="cts-concepts-list">
                                                        {concepts.map((concept, i) => (
                                                            <div key={i} className="cts-concept-row">
                                                                <Caption1 className="cts-concept-name">{concept.ConceptName}</Caption1>
                                                                <div className="cts-concept-right">
                                                                    <Text size={200} weight="semibold">{fmt(concept.Total, concept.CurrencyValue)}</Text>
                                                                    <Caption1 style={{ color: '#888' }}>
                                                                        CM: {fmt(concept.TotalOwner, concept.CurrencyValue)} · IP: {fmt(concept.TotalTeam, concept.CurrencyValue)}
                                                                    </Caption1>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </AccordionPanel>
                            </AccordionItem>
                        );
                    })}
                </Accordion>
            </div>

            <div className="cts-actions">
                <Button appearance="primary" onClick={openPanel}>
                    Generar Liquidación&nbsp;<Badge>{props.Consumptions.length}</Badge>
                </Button>
            </div>

            <SettlementFormComponent
                isOpen={isOpen}
                dismissPanel={dismissPanel}
                openPanel={openPanel}
                ContractId={props.contract?.id}
                PractitionerId={undefined}
                ProtocolId={props.ProtocolId}
                MedicalAgreementId={undefined}
                MedicalInsuranceId={undefined}
            />
        </div>
    );
};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(ConsumptionToSettleComponent as any);